import { Link } from 'react-router';
import { HomeRewardsSection } from '@/features/market/components/home/HomeRewardsSection';
import { PromotionList } from '@/features/promotions/components/PromotionList';
import { HomeRaceSection } from '@/features/races/components/HomeRaceSection';
import { FeaturedSitesStrip } from '@/features/sites/components/FeaturedSitesStrip';
import { SpotlightBanner } from '@/features/sites/components/SpotlightBanner';
import { StreamerCard } from '@/features/streamer/StreamerCard';
import { env } from '@/lib/env';

/** Public highlights followed by the member’s Market and Milestone journey. */
export function HomePage() {
  return (
    <div className="home-flow">
      {/*
        The design has no visible page title — the logo and the sections carry
        it. A screen reader still needs one, and a page whose first heading is an
        h2 reads as a fragment of something larger.
      */}
      <h1 className="sr-only">{env.appName} — ana sayfa</h1>

      <FeaturedSitesStrip />
      <SpotlightBanner />
      <StreamerCard />
      <HomeRaceSection />
      <HomeRewardsSection />

      <section aria-labelledby="active-promotions">
        <div className="mb-3 flex items-center justify-between gap-4">
          <h2 id="active-promotions" className="section-title flex items-center gap-2">
            <svg aria-hidden viewBox="0 0 24 24" className="size-4 fill-current">
              <path d="M11.6 2.6 21 12l-9 9-9.4-9.4A2 2 0 0 1 2 10.2V4a2 2 0 0 1 2-2h6.2c.5 0 1 .2 1.4.6zM7 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z" />
            </svg>
            Promosyonlar
          </h2>

          <Link to="/promotions" className="section-link">
            Tümünü gör
          </Link>
        </div>

        {/* Featured only: the home page shows a handful, the list page shows
            everything. */}
        <PromotionList featuredOnly skeletonCount={3} />
      </section>
    </div>
  );
}
